import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import { MapWrapper } from './styles';

const GoogleMap = ({ children, onGoogleApiLoaded, height, center, zoom }) => (
  <MapWrapper $mapHeight={height} className="chromatic-ignore">
    <GoogleMapReact
      bootstrapURLKeys={{
        key: process.env.GOOGLE_MAPS_API_KEY,
      }}
      zoom={zoom || 6}
      center={center || { lat: 54.5, lng: -1.5 }}
      yesIWantToUseGoogleMapApiInternals
      onGoogleApiLoaded={({ map, maps }) => onGoogleApiLoaded(map, maps)}
    >
      {children}
    </GoogleMapReact>
  </MapWrapper>
);

GoogleMap.propTypes = {
  center: PropTypes.object,
  zoom: PropTypes.number,
  height: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  onGoogleApiLoaded: PropTypes.func,
};

GoogleMap.defaultProps = {
  children: null,
};

export default GoogleMap;
